import React, { useState } from 'react';
import { Loader, Message, Panel, Stack, useToaster } from 'rsuite';
import Lottie from 'react-lottie';
import animationData from '@/images/Locked.json';
import PinInput from 'react-pin-input';
import { resetPassword } from '@/services/auth.service';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import Copyright from '@/components/Copyright';

const PinInputComponent = PinInput as React.FC<PinInputProps>;

const MFAForgot = () => {
  const { t } = useTranslation();
  const toaster = useToaster();
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || '';
  const [loading, setLoading] = useState(false);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  const handleChange = async value => {
    if (!value || value.length !== 6) {
      toaster.push(
        <Message closable showIcon type="error">
          {t('Please enter a 6-digit code')}
        </Message>,
        { placement: 'topCenter', duration: 3000 }
      );
      return;
    }

    setLoading(true);
    try {
      const response = await resetPassword(email, value);
      console.log('Reset password response:', response);
      toaster.push(
        <Message closable showIcon type="success">
          {t(response.message || 'Your new password has been sent, please check your inbox')}
        </Message>,
        { placement: 'topCenter', duration: 5000 }
      );
      setTimeout(() => navigate('/signin'), 2000);
    } catch (error) {
      console.error('Reset password error:', error);
      toaster.push(
        <Message closable showIcon type="error">
          {t(error.message || 'Invalid or expired validation code')}
        </Message>,
        { placement: 'topCenter', duration: 3000 }
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Stack
        justifyContent="center"
        alignItems="center"
        direction="column"
        style={{
          height: '95vh'
        }}
      >
        <Panel style={{ width: 400 }}>
          <center>
            <Lottie options={defaultOptions} height={250} width={250} />
            <h3 style={{ marginBottom: 10 }}>{t('Code Verification')}</h3>
            <p className="error-page-subtitle text-muted">
              {t('Please enter the code sent to your email to reset your password')}
            </p>
          </center>
          <PinInputComponent
            length={6}
            initialValue=""
            type="numeric"
            inputMode="number"
            style={{ padding: '10px', display: 'flex', justifyContent: 'center' }}
            inputStyle={{ borderColor: 'black', width: '40px', height: '40px', margin: '0 5px' }}
            inputFocusStyle={{ borderColor: 'blue' }}
            onComplete={value => handleChange(value)}
            autoSelect={true}
            regexCriteria={/^[0-9]*$/}
          />
          {loading && (
            <center>
              <Loader color="blue" />
            </center>
          )}
        </Panel>
        <Copyright />
      </Stack>
    </div>
  );
};

export default MFAForgot;
